import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Base from '../../utils/base'
import moment from "moment";
import { useSearchParams } from 'react-router-dom';

export default function Article(props) {
  var base = new Base()
  const {t, i18n} = useTranslation()

  const momentNow = moment()
  const [searchParams, setSearchParams] = useSearchParams();
  const [articleData, setArticleData] = useState({})
  const [arrArticle, setArrArticle] = useState([])

  useEffect(() => {
    var lang = window.localStorage.getItem('lang')
		i18n.changeLanguage(lang != null ? lang : 'en')

    get_data()
    get_all_data()
  }, [])

  async function get_data() {
    var response = await base.request(base.url_api + "/article?id=" + searchParams.get('id'))

    if (response != null) {
      if (response.status == "success") {
        // for(let data of response.data){
        //   data.image = data.url_image
        // }
        response.data.image = response.data.url_image
        response.data.createdDate = moment(response.data.created_at)
        setArticleData(response.data)
      }
      else
        base.show_error(response.message)
    }
    else
      console.log('Server Error')
  }

  async function get_all_data() {
    var response = await base.request(base.url_api + "/article")

    if (response != null) {
      if (response.status == "success") {
        for(let data of response.data){
          data.image = data.url_image
          data.createdDate = moment(data.created_at)
        }
        // response.data.image = response.data.url_image
        // response.data.createdDate = moment(response.data.created_at)
        setArrArticle(response.data)
      }
      else
        base.show_error(response.message)
    }
    else
      console.log('Server Error')
  }

  return (
    <section className="blog-one blog-one--page">
      <div className="container">
        <div className="row gutter-y-60">
          <div className="col-lg-8">
            <div className="blog-details">
              <div className="blog-card__two">
                <div className="blog-card__two__image">
                  <img src={articleData.image} alt="solinom" />
                  {
                    articleData.createdDate != null &&
                    <div className="blog-card__two__date" style={{ fontSize: '.8rem', }}> <span className="blog-card__two__date__day" style={{ fontSize: '1.875rem', }}>{articleData.createdDate.format('DD')}</span>{articleData.createdDate.format('MMM')}</div>
                  }
                  
                </div>
                <div className="blog-card__two__content">
                  {/* <ul className="list-unstyled blog-card__two__meta">
                    <li className="blog-card__two__meta__item"><a href="team.html"> <i className="fas fa-user-circle"></i>By admin</a></li>
                    <li className="blog-card__two__meta__item"><a href="blog-details.html"> <i className="icon-bubble-chat-1"></i> 2 Comment</a></li>
                  </ul> */}
                  <h3 className="blog-card__two__title text-uppercase" style={{ fontSize: '1.875rem', }}>{articleData.title}</h3>
                  <p className="blog-card__two__text" style={{ fontSize: '1rem', }}>{base.capitalizeFirstLetter(articleData.content)}</p>
                  
                </div>
              </div>

              {/* <div className="blog-details__meta">
                <div className="blog-details__tags wow fadeInUp" data-wow-delay='300ms'>
                  <h4 className="blog-details__tags__title">Post In: </h4>
                  <div className="sidebar__tags">
                    <a href="#" className="solinom-btn">Technology</a>
                    <a href="#" className="solinom-btn">IT Industry</a>
                  </div>
                </div>

                <div className="blog-details__tags wow fadeInUp" data-wow-delay='500ms'>
                  <h4 className="blog-details__tags__title">Tags: </h4>
                  <div className="sidebar__tags2">
                    <a href="#">Safty</a> <span> , </span> <a href="#">Learning</a>
                  </div>
                </div>
              </div> */}
            </div>

            {/* <div className="comments-one">
              <h3 className="comments-one__title wow fadeInUp" data-wow-delay='300ms'>2 Comments</h3>
              <ul className="list-unstyled comments-one__list">
                <li className="comments-one__card wow fadeInUp" data-wow-delay='300ms'>
                  <div className="comments-one__card__image">
                    <img src="assets/images/blog/blog-comment-1-1.jpg" alt="" />
                  </div>
                  <div className="comments-one__card__content">
                    <h3 className="comments-one__card__title">David Shon</h3>
                    <p className="comments-one__card__text">Nam vel lacus eu nisl bibendum accumsan vitae vitae nibh. Nam nec eros id magna hendrerit sagittis. Nullam sed mi non odio feugiat volutpat sit amet nec elit.Nisl bibendum accumsan vitae vitae </p>
                    <div className="comments-one__card__btn">
                      <a href="blog-details-right.html" className="solinom-btn comments-one__card__reply">Reply</a>
                    </div>
                  </div>
                </li>
                <li className="comments-one__card wow fadeInUp" data-wow-delay='300ms'>
                  <div className="comments-one__card__image">
                    <img src="assets/images/blog/blog-comment-1-2.jpg" alt="" />
                  </div>
                  <div className="comments-one__card__content">
                    <h3 className="comments-one__card__title">Jhon Watchson</h3>
                    <p className="comments-one__card__text">Nam vel lacus eu nisl bibendum accumsan vitae vitae nibh. Nam nec eros id magna hendrerit sagittis. Nullam sed mi non odio feugiat volutpat sit amet nec elit.Nisl bibendum accumsan vitae vitae </p>
                    <div className="comments-one__card__btn">
                      <a href="blog-details-right.html" className="solinom-btn comments-one__card__reply">Reply</a>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div className="comments-form">
              <h3 className="comments-form__title wow fadeInUp" data-wow-delay='300ms'>Leave a Comment</h3>
              <form className="comments-form__form contact-form-validated form-one wow fadeInUp" data-wow-delay='300ms'>
                <div className="form-one__group">
                  <div className="form-one__control">
                    <input type="text" name="name" placeholder="Your Name" />
                  </div>
                  <div className="form-one__control">
                    <input type="email" name="email" placeholder="Email Address" />
                  </div>
                  <div className="form-one__control form-one__control--full">
                    <textarea name="message" placeholder="Write a Message"></textarea>
                  </div>
                  <div className="form-one__control">
                    <button type="submit" className="solinom-btn solinom-btn--base">Submit a Comment</button>
                  </div>
                </div>
              </form>
              <div className="result"></div>
            </div> */}
          </div>
          <div className="col-lg-4">
            <div className="sidebar">
              <aside className="widget-area">
                {/* <div className="sidebar__single--search wow fadeInUp" data-wow-delay='300ms'>
                  <form action="#" className="sidebar__search">
                    <button type="submit" aria-label="search submit">
                      <span><i className="icon-search"></i></span>
                    </button>
                    <input type="text" placeholder="Type Here" />
                  </form>
                </div> */}

                <div className="sidebar__single wow fadeInUp" data-wow-delay='300ms'>
                  <h4 className="sidebar__title" style={{ fontSize: '1.5rem', }}>{t('latest_post')}</h4>
                  <ul className="sidebar__posts list-unstyled">

                    {
                      arrArticle.map((article, index) => (
                        <li className="sidebar__posts__item">
                          <div className="sidebar__posts__image">
                            <img src={article.image} alt="solinom" />
                          </div>
                          <div className="sidebar__posts__content">
                            <p className="sidebar__posts__meta" >
                              <a href="#" style={{ fontSize: '1rem', }}><i className="icon-clock-outline"></i>{article.createdDate.format('DD MMMM YYYY')}</a>
                            </p>
                            <h4 className="sidebar__posts__title" style={{ fontSize: '1rem', }}>
                              <a href={'/article?id=' + article.id}>{base.capitalizeFirstLetter(article.title)}</a>
                            </h4>
                          </div>
                        </li>
                      ))
                    }
                    
                  </ul>
                </div>

                {/* <div className="sidebar__single wow fadeInUp" data-wow-delay='300ms'>
                  <h4 className="sidebar__title">Categories</h4>
                  <ul className="sidebar__categories list-unstyled">
                    <li className="sidebar__categories__item"><a href="#"> <i className="icon-right-arrow2"></i> Technology</a></li>
                    <li className="sidebar__categories__item"><a href="#"> <i className="icon-right-arrow2"></i> Digital Marketing</a></li>
                    <li className="sidebar__categories__item"><a href="#"> <i className="icon-right-arrow2"></i> UI/UX Design</a></li>
                    <li className="sidebar__categories__item"><a href="#"> <i className="icon-right-arrow2"></i> It Solution</a></li>
                    <li className="sidebar__categories__item"><a href="#"> <i className="icon-right-arrow2"></i> Digital Solution</a></li>
                  </ul>
                </div>

                <div className="sidebar__single wow fadeInUp" data-wow-delay='300ms'>
                  <h4 className="sidebar__title">Tags</h4>
                  <div className="sidebar__tags">
                    <a className="sidebar__tag__item" href="#">Marketing</a>
                    <a className="sidebar__tag__item" href="#">Technology</a>
                    <a className="sidebar__tag__item" href="#">UI/UX Design</a>
                    <a className="sidebar__tag__item" href="#">Design</a>
                  </div>
                </div>

                <div className="sidebar__single wow fadeInUp" data-wow-delay='300ms'>
                  <h4 className="sidebar__title">Comments</h4>
                  <ul className="sidebar__comments list-unstyled">
                    <li className="sidebar__comments__item">
                      <div className="sidebar__comments__icon"> <i className="icon-bubble-chat-1"></i></div>
                      <h6 className="sidebar__comments__title">
                        <a href="#">There are maniey free good variations lorem ispum is available</a>
                      </h6>
                    </li>
                    <li className="sidebar__comments__item">
                      <div className="sidebar__comments__icon"> <i className="icon-bubble-chat-1"></i> </div>
                      <h6 className="sidebar__comments__title">
                        <a href="#">There are maniey free good variations lorem ispum is available</a>
                      </h6>
                    </li>
                    <li className="sidebar__comments__item">
                      <div className="sidebar__comments__icon"> <i className="icon-bubble-chat-1"></i> </div>
                      <h6 className="sidebar__comments__title">
                        <a href="#">There are maniey free good variations lorem ispum is available</a>
                      </h6>
                    </li>
                    <li className="sidebar__comments__item">
                      <div className="sidebar__comments__icon"> <i className="icon-bubble-chat-1"></i> </div>
                      <h6 className="sidebar__comments__title">
                        <a href="#">There are maniey free good variations lorem ispum is available</a>
                      </h6>
                    </li>
                  </ul>
                </div> */}
              </aside>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
